import React, { FC } from "react";
import { useRouter } from "next/router";

import SchemaLink from "src/components/index/schemas/SchemaLink";
import { schemaPath } from "src/lib/schemaOrgUrl";
import { Subject } from "src/lib/graphql/types";

const SchemaBreadcrumbs: FC<{
  name: string;
  namespace: string;
  ancestors?: Pick<Subject, "name" | "namespace">[];
}> = ({ ancestors, name, namespace }) => {
  const router = useRouter();

  return (
    <ul className="schema-breadcrumbs listing-category">
      {/* <li className="schema-type-select">
        <label htmlFor="root-select">Schemas ▾</label>
        <select
          onChange={async (evt) => {
            evt.preventDefault();

            await router.push(schemaPath({ name, namespace }));
          }}
          value={ancestors?.[0]?.name ?? name}
          name="root-select"
          id="root-select"
        >
          <option value="Thing">Thing</option>
          <option value="DataType">DataType</option>
        </select>
      </li> */}
      {ancestors?.map(({ name, namespace }) => (
        <li key={name}>
          <SchemaLink href={schemaPath({ name, namespace })}>{name}</SchemaLink>
        </li>
      ))}
    </ul>
  );
};

export default SchemaBreadcrumbs;
